import { usePreview } from "features/preview/Feature";
import { Box, Button, Dropdown, Input, Stack, Tooltip } from "prism-react";
import { useRef } from "react";

import { RefreshButton } from "./RefreshButton";

export const NavigationBar: React.FC<{
  isConnected: boolean;
  onRefresh: () => void;
  onGoBack: () => void;
  onGoForward: () => void;
  setIframeUrl: (url: string) => void;
  actions: JSX.Element[];
  secondaryActions?: JSX.Element[];
}> = ({
  isConnected,
  onGoBack,
  onGoForward,
  onRefresh,
  actions,
  setIframeUrl,
  secondaryActions,
}) => {
  const [preview, send] = usePreview();
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <Box
      css={{
        display: "flex",
        height: "$11",
        px: "$2",
      }}
    >
      <Stack css={{ width: "100%" }} gap={1} horizontal>
        <Tooltip content="Back">
          <Button
            disabled={!isConnected || !preview.canGoBack}
            icon="chevronLeft"
            onClick={() => onGoBack()}
          />
        </Tooltip>
        <Tooltip content="Forward">
          <Button
            disabled={!isConnected || !preview.canGoForward}
            icon="chevronRight"
            onClick={() => onGoForward()}
          />
        </Tooltip>

        <RefreshButton isConnected={isConnected} onRefresh={onRefresh} />

        <Input
          ref={inputRef}
          css={{
            flex: 1,
            width: "100%",
            backgroundColor: "transparent",
            "&:focus": {
              outline: "none",
              color: "$neutral-fg-high",
            },
          }}
          onChange={(event) => {
            send({
              type: "INPUT_CHANGE",
              url: event.currentTarget.value,
            });
          }}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              setIframeUrl(event.currentTarget.value);
            } else if (event.key === "Escape") {
              send({ type: "INPUT_CANCEL" });
            }
          }}
          value={preview.urlInputValue}
          width="full"
        />

        {actions}
        {secondaryActions && secondaryActions.length > 0 && (
          <Dropdown trigger={<Button aria-label="options" icon="more" />}>
            {secondaryActions}
          </Dropdown>
        )}
      </Stack>
    </Box>
  );
};
